import { translate as t } from '@thoughtspot/i18n';
import { FormBuilder } from '@thoughtspot/radiant-react/widgets/form-builder';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import React from 'react';
import { Title } from '../../settings/setting/title';
import styles from './chart-customization-settings.module.scss';
import { TranslationKeys } from './settings.constants';
import { buildToggleField } from './settings.field';
export const SettingsView = ({ enabled, onEdit, }) => (React.createElement("div", { className: styles.settingsContainer },
    React.createElement(Title, { settingTitle: t(TranslationKeys.SETTINGS_HEADER), actions: [
            {
                title: t(TranslationKeys.EDIT_ACTION),
                type: 'EDIT',
            },
        ], actionHandler: () => onEdit() }),
    React.createElement(Vertical, null,
        React.createElement(FormBuilder, { formFields: [buildToggleField(enabled)], viewMode: "view" }))));
//# sourceMappingURL=settings-view.js.map